import type { FC } from 'react';
import { Suspense } from 'react';

import type { CompaniesIndustry } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { useAllIndustries } from '../../hooks/use-companies-industries';
import { createCompaniesIndustries } from '../../models/industry';
import { ROUTES } from '../../routes';
import { IndustryCard } from '../industry-card/industry-card';
import { SectionContainer } from '../section-container/section-container';

import * as Styled from './section-companies-by-industry.styles';

const LIMIT = 6;

const SectionCompaniesByIndustriesInner: FC = () => {
  const { isLoggedIn } = useLoginState();
  const linkUri = isLoggedIn ? undefined : ROUTES.industries;
  const { orderedIndustries } = useAllIndustries();

  const subsetIndustries = isLoggedIn
    ? orderedIndustries
    : orderedIndustries.slice(0, LIMIT);

  const collection = (subsetIndustries ?? []) as CompaniesIndustry[];
  const industriesCollection = createCompaniesIndustries(collection);

  if (industriesCollection.length === 0) {
    return null;
  }

  return (
    <SectionContainer
      title="CP_INDUSTRIES_SECTION_TITLE"
      subtitle="CP_INDUSTRIES_SECTION_SUBLINE"
      linkUri={linkUri}
    >
      <Styled.GridIndustries>
        {industriesCollection.map((item) => (
          <IndustryCard key={item.id} item={item} />
        ))}
      </Styled.GridIndustries>
    </SectionContainer>
  );
};

export const SectionCompaniesByIndustries: FC = () => {
  const { isLoggedIn } = useLoginState();
  const linkUri = isLoggedIn ? undefined : ROUTES.industries;
  return (
    <Suspense
      fallback={
        <SectionContainer
          title="CP_INDUSTRIES_SECTION_TITLE"
          subtitle="CP_INDUSTRIES_SECTION_SUBLINE"
          linkUri={linkUri}
        >
          <>
            {Array.from({ length: LIMIT }).map((_, index) => (
              <IndustryCard.Skeleton key={index} />
            ))}
          </>
        </SectionContainer>
      }
    >
      <SectionCompaniesByIndustriesInner />
    </Suspense>
  );
};
